module.exports = __webpack_public_path__ + "img/loading.e9415100.svg";